import React, { useState } from "react";
import { useForm, Controller } from "react-hook-form";
import { Grid, Typography, TextField, Box, FormControl, InputLabel, Modal, Select, MenuItem, FormHelperText } from "@mui/material";
import { Button } from "react-bootstrap";
import { useBulkUploadMutation } from "../../../app/services/memberServices";
import { toast } from "react-toastify";
import { planType } from "../../../constant/constant";


const MemberBulkUpload = () => {
    const [bulkUpload] = useBulkUploadMutation();
    const [selectedPlan, setSelectedPlan] = useState("");
    const [selectedPlanType, setSelectedPlanType] = useState("");
    const [open, setOpen] = useState(false);

    const {
        control,
        handleSubmit,
        setError,
        setValue,
        clearErrors,
        formState: { errors },
    } = useForm({
        mode: "onChange",
        defaultValues: {
            type: '',
            file: null, // ✅ Default should be `null` instead of an empty string
        },
    });


    //validTation for the excel file
    const validateFile = (file) => {
        if (!file) return "File is required!";

        const allowedTypes = [
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", // .xlsx
            "application/vnd.ms-excel", // .xls
        ];
        // const maxSize = 2 * 1024 * 1024; // 2MB size limit

        if (!allowedTypes.includes(file.type)) return "Only Excel files are allowed!";
        // if (file.size > maxSize) return "File size should not exceed 2MB!";

        return true;
    };

    // Mapping plans to their respective Excel file URLs
    const fileMap = [
        { name: "Individual Teacher", link: "assets/excel/Teacher_Membership.xlsx" },
        { name: "Dual Teacher", link: "assets/excel/Corporate_Membership.xlsx" },
        { name: "Individual Student", link: "assets/excel/Student_Membership.xlsx" },
        { name: "Institution", link: "assets/excel/Institution_Membership.xlsx" },
        { name: "Corporate Supporter", link: "assets/excel/Corporate_Membership.xlsx" }
    ];


    //download the  files based on the membership details selcted
    const handleDownload = () => {

        const selectedPlanObject = fileMap.find((plan) => plan.name.trim() === selectedPlan.trim());

        const fileName = selectedPlanObject.link.split("/").pop(); // Extracts file name
        const fileURL = `/assets/excel/${fileName}`;

        // Create a temporary anchor element to trigger download
        const link = document.createElement("a");

        link.href = fileURL;
        link.setAttribute("download", fileName); // Use only the file name
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    // Member bulkupload integration
    const uploadMember = (data) => {
        const formData = new FormData();
        formData.append("file", data.file);
        formData.append("type", data.type);
        bulkUpload(formData).then((res) => {
            if (res?.data?.status) {
                toast.success(res?.data?.message)
                setValue("file", "");
                setValue("type", "");

            } else {
                toast.error(res?.data?.error)
            }
        })
            .catch((error) => {
                console.error("Upload Error:", error);
            });
    };

    const handleClose = () => {
        setOpen(false)
    }
    const handleOpen = () => {
        setOpen(true);
    };
    //Modal usage
    const style = {
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        maxWidth: 500,
        minWidth: 300,
        height: "40%",
        bgcolor: "background.paper",
        boxShadow: 24,
        padding: 4,
    };

    return (
        <Box>
            <div className="pt-5 ">
                <div className="chapter-heading">
                    <h2 className="text-center title-font text-light py-3 mt-1">
                        Bulk Upload New Member
                    </h2>
                </div>
            </div>

            <div className="p-3 p-md-5 overallpadding d-flex flex-column align-items-center">
                <div className="text-center w-100">
                    <p><button
                        style={{
                            textDecoration: "underline",
                            backgroundColor: "transparent",
                            border: "none",
                            color: "var(--all-menus-color)",
                            cursor: "pointer",
                            padding: 0,
                        }}
                        onClick={handleOpen}
                    >
                        Download
                    </button> the excel sheet and fill out the membership details for the bulk upload.</p>
                </div>

                <form onSubmit={handleSubmit(uploadMember)} className="mt-4 w-100">
                    <Grid container spacing={3} justifyContent="center">
                        <Grid item xs={12} md={2}></Grid>
                        <Grid item xs={12} md={3}>
                            <FormControl fullWidth style={{ maxWidth: 400, margin: "0 auto" }} error={!!errors.type}                            >
                                <InputLabel className="text-dark">Membership Plan</InputLabel>
                                <Controller
                                    name="type"
                                    control={control}
                                    defaultValue=""
                                    rules={{
                                        required: "Please select a membership Type", // Validation rule
                                    }}
                                    render={({ field }) => (
                                        <Select
                                            {...field}
                                            label={
                                                <Typography className="text-dark">
                                                    Membership Plan <span style={{ color: "red" }}>*</span>
                                                </Typography>
                                            }
                                            value={selectedPlanType}
                                            className="bg-white"
                                            onChange={(e) => {
                                                setSelectedPlanType(e.target.value);
                                                field.onChange(e);
                                            }}
                                        >
                                            <MenuItem value="">
                                                <em>Select MembershipType</em>
                                            </MenuItem>
                                            {planType.map((plan, index) => (
                                                <MenuItem key={index} value={plan.planId}>
                                                    {plan.planName}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    )}
                                />
                                {errors.type && (
                                    <FormHelperText>{errors.type.message}</FormHelperText>
                                )}

                            </FormControl>
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <Controller
                                name="file"
                                control={control}
                                rules={{
                                    required: "Please select an Excel file",
                                    validate: validateFile,
                                }}
                                render={({ field: { onChange, ref } }) => (
                                    <TextField
                                        inputRef={ref}
                                        InputProps={{ type: "file" }}
                                        fullWidth
                                        InputLabelProps={{ shrink: true }}
                                        label={
                                            <Typography className="text-dark">
                                                Upload File <span style={{ color: "red" }}>*</span>
                                            </Typography>
                                        }
                                        inputProps={{ accept: ".xls,.xlsx" }}
                                        error={!!errors?.file}
                                        helperText={errors?.file?.message}
                                        onChange={(e) => {
                                            const fileList = e.target.files;

                                            if (!fileList || fileList.length === 0) {
                                                setError("file", { message: "Please select a file!" });
                                                return;
                                            }

                                            const file = fileList[0];
                                            const validationResult = validateFile(file);

                                            if (validationResult === true) {
                                                onChange(file);
                                                clearErrors("file");
                                            } else {
                                                e.target.value = "";
                                                setError("file", { message: validationResult });
                                            }
                                        }}
                                    />
                                )}
                            />
                        </Grid>
                        <Grid item xs={12} md={2} className="mt-2">
                            <Button variant="contained" className="menus-color" type="submit">
                                Upload
                            </Button>
                        </Grid>
                        <Grid item xs={12} md={1}></Grid>
                    </Grid>

                    {/* <div className="d-flex justify-content-center mt-3">
                        
                    </div> */}
                </form>
            </div>
            <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Grid
                    sx={style}
                    container
                    className="overflow-y-scroll no-scrollbar"
                >
                    <h2 className="mb-3 text-center"><b>Download Excel</b></h2>
                    <hr className="line" />
                    <Grid container spacing={3} justifyContent="center" >

                        {/* <Grid item xs={12} md={4}> */}
                        <FormControl fullWidth style={{ maxWidth: 400, margin: "0 auto" }} >
                            <InputLabel className="text-dark">Membership Plan</InputLabel>
                            <Select label={
                                <Typography className="text-dark">
                                    Membership Plan
                                </Typography>
                            } value={selectedPlan} onChange={(e) => setSelectedPlan(e.target.value)}>
                                {fileMap.map((plan, index) => (
                                    <MenuItem key={index} value={plan.name}>
                                        {plan.name}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                        {/* </Grid> */}
                    </Grid>
                    <div className="text-center d-flex justify-content-center w-100 ">
                        <Button variant="outlined"
                            style={{
                                color: "#dc3545",
                                border: "1px solid #dc3545",
                                padding: "5px 15px",
                                borderRadius: "0px",
                            }} onClick={handleClose} >
                            cancel
                        </Button>
                        <Button variant="contained" className="ms-3 menus-color" onClick={handleDownload} disabled={!selectedPlan}>
                            Download Excel
                        </Button>

                    </div>

                </Grid>
            </Modal>
        </Box >
    );
};

export default MemberBulkUpload;

